export default __webpack_public_path__ + "static/media/paid-cash.cf7bca6d.svg";